import { render } from "./Browser.vue?vue&type=template&id=4604243a&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=4604243a&lang=css"
import "./Browser.vue?vue&type=style&index=1&id=4604243a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4604243a"]])

export default __exports__